export const getHref = () => {
  return window.location.href;
};

export const replaceHref = (href: string) => {
  window.location.replace(href);
};
